module.exports = __webpack_public_path__ + "media/images/camera-48f5daa53dcc1558e51db519fe148a78.svg";